import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="898.997" height="890.498" viewBox="0 0 898.997 890.498" className={props.className}>
            <path id="Path_2" data-name="Path 2" d="M540.081,113.988ZM651.432,642.962l-263.5-91.8L539.61,115.808a11.812,11.812,0,0,0,.383-1.309,7.129,7.129,0,0,0-2.236-1.992,13.313,13.313,0,0,0-1.254.538L121.4,313.638,0,62.4,415.1-138.2A281.28,281.28,0,0,1,803.1,207.613Z" transform="matrix(-0.995, 0.105, -0.105, -0.995, 881.607, 639.44)" fill="#d7f2dc"/>
        </svg>
    );
}